var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{attrs:{"id":"loading"}},[_c('div',{staticStyle:{"z-index":"9999"}},[_c('van-loading',{attrs:{"color":"#00ab87","size":"60px","text-size":"20px","vertical":""}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }